// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1lk7A","link":"style_link__DI4ot"};